import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'productCategoryPaginate',
    serviceName: 'graphql',
    query: gql`
      query productCategoryPaginate($ids: [String]) {
        productCategoryPaginate(ids: $ids) {
          data {
            id
            title
            media {
              id
              full_url
            }
          }
        }
      }
    `,
  },
};

export default schema;
